import Admin, { hasRole, Role } from '@/models/Admin'
import Rider from '@/models/Rider'

export default class RiderPolicy {
	viewAny(_admin: Admin): boolean {
		return true
	}

	view(admin: Admin, rider: Rider) {
		return hasRole(admin, [Role.SUPER_ADMIN,Role.STATION_MANAGER, Role.STATION_OFFICER,Role.FINANCIER]) 
	}

	create(admin: Admin) {
		return hasRole(admin, [Role.SUPER_ADMIN,Role.STATION_MANAGER, Role.STATION_OFFICER])
	}

	update(admin: Admin, rider: Rider) {
		return hasRole(admin, [Role.SUPER_ADMIN,Role.STATION_MANAGER, Role.STATION_OFFICER])
	}

	restore(admin: Admin, rider: Rider) {
		return hasRole(admin, [Role.SUPER_ADMIN])
	}

	delete(admin: Admin, rider: Rider) {
		return hasRole(admin, [Role.SUPER_ADMIN])
	}

	forceDelete(_admin: Admin, _rider: Rider) {
		return false
	}
}
